import { exp } from "./export";
import { lang } from '../lang.js';

exp.resetEditor = () => {
    if (!b3.exportOptions) return;
    const editor = document.querySelector('[trix-id="1"]')?.editor;
    if (!editor) return;

    // clear the editor
    editor.loadHTML('');
    editor.setSelectedRange(0);

    const hasSymbols = b3.store.state.swatches.some(swatch => !!swatch.letterCode);

    if (!hasSymbols) {
        editor.insertHTML('Your beads do not yet have associated symbols.<br>Assign symbols to each bead in the Palette menu area, then reset word chart.');
        return;
    }

    const elementsArr = exp.getWordChartsOnly({options: b3.exportOptions, fromEditorTab: true});
    let myHTML = '';

    if (!elementsArr) return;

    elementsArr.forEach(element => {
        if (element.style === 'header') myHTML += '<h1>' + element.text + '</h1>';
        else {
            element.text.text.forEach(obj => {
                myHTML += exp.wordChartToHTML(obj);
            });
        }
    });
    editor.insertHTML(myHTML);
};

b3.resetEditorButton = () => {
    b3.renderModal(lang.get('reset editor warning message','Any changes to the word chart will be lost. Continue?'), () => {
        exp.resetEditor();
        b3.hideModal();
    }, null);
};

exp.wordChartToHTML = element => {
    if (element === '\n') return '<br>';
    if (typeof element === 'string') return element;
    if (element.bold) return '<strong>' + element.text + '</strong>';
    return element.text;
};

exp.getCustomWordChart = () => {
    let result = [];
    let myContents = [];
    const elementsArr = document.querySelector('[trix-id="1"]').editor.getDocument().blockList.objects;
    elementsArr.forEach(element => {
        if (element.attributes.length) {
            if (element.attributes[0] === 'heading1') {
                result.push({
                    text: element.text.pieceList.objects[0].string,
                    style: 'header'
                });
                return;
            }
        }
        myContents = [];
        element.text.pieceList.objects.forEach(obj => {
            if (obj.attributes.values.bold) {
                myContents.push({
                    text: obj.string,
                    bold: true
                });
            } else {
                myContents.push(obj.string);
            }
        });
        result.push({
            text: {text: myContents},
            style: 'wordChart'
        });
    });
    return result;
};
